import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export const SkeletonGrid = () =>
  Array(10)
    .fill(0)
    .map((_, index) => (
      <Box key={index}>
        <Skeleton animation="wave" height={94} sx={skeletonStyles} />
      </Box>
    ));

const skeletonStyles = {
  borderRadius: 0,
};
